// src/utils/api.js
export const API_BASE = import.meta.env.VITE_API_BASE || "http://localhost:8080";

export const apiFetch = async (endpoint, options = {}, withAuth = false, allowAnonymous = false) => {
  const attemptRequest = async (token) => {
    const headers = {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    };

    console.log(`${endpoint} WITH ${token}`);

    const response = await fetch(`${API_BASE}${endpoint}`, {
      ...options,
      headers,
    });

    return response;
  };

  const authToken = localStorage.getItem("authToken");
  const userToken = localStorage.getItem("userToken");

  let token = null;

  if (withAuth) {
    token = authToken;
  } else if (allowAnonymous) {
    token = authToken || userToken;

    if (!token) {
      const generateUUID = () => {
        if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
          return crypto.randomUUID();
        }
        // Fallback UUID generator
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = Math.random() * 16 | 0;
          const v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      };
    
      const newToken = generateUUID();
      localStorage.setItem("userToken", newToken);
      token = newToken;
    }
  }

  let response = await attemptRequest(token);

  if (response.status === 401 && withAuth && authToken) {
    const refreshToken = localStorage.getItem("authRefreshToken");

    const refreshResponse = await fetch(`${API_BASE}/auth/refresh`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ refreshToken })
    });

    if (refreshResponse.ok) {
      const tokens = await refreshResponse.json();
      localStorage.setItem("authToken", tokens.tokens.access.token);
      localStorage.setItem("authRefreshToken", tokens.tokens.refresh.token);

      response = await attemptRequest(tokens.tokens.access.token);
    } else {
      console.error("❌ Failed to refresh token, clearing session");
      localStorage.removeItem("authToken");
      localStorage.removeItem("authRefreshToken");
      return refreshResponse;
    }
  }

  if (!response.ok) {
    console.error(`❌ API error on ${endpoint}:`, response.status);
  }

  return response.json();
};